import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
import { cookieComplianceReducer } from '@uncinc/react-cookie-compliance';
import {
  entityReducer,
  menuReducer,
  viewReducer,
  viewInfoReducer,
  nodeReducer,
  webformReducer,
  blockReducer,
  paragraphReducer,
  taxonomyReducer,
  uiReducer,
} from '@uncinc/react-drupal-core';

import uiInternal from './UI';

import debug from './Debug';
import modalReducer from './Modal';

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  debug,
  entity: entityReducer,
  menu: menuReducer,
  node: nodeReducer,
  webform: webformReducer,
  block: blockReducer,
  paragraph: paragraphReducer,
  view: viewReducer,
  viewInfo: viewInfoReducer,
  taxonomyTerm: taxonomyReducer,
  ui: uiReducer,
  cookieCompliance: cookieComplianceReducer,
  uiInternal: uiInternal,
  modal: modalReducer,
});

export default rootReducer;
